import { render, staticRenderFns } from "./GridSubmitSourced.vue?vue&type=template&id=56053696&"
import script from "./GridSubmitSourced.vue?vue&type=script&lang=js&"
export * from "./GridSubmitSourced.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports